export const DETAILS_BUTTON_TEXT = "Detail";

// #region TEST IDs
export const EXPANDED_ROW_TEST_ID = "expanded-row";
export const DETAILS_BUTTON_TEST_ID = "details-button";
// #endregion
